module.exports = __webpack_public_path__ + "img/default-logo-horizontal.37d39ee4.svg";